import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.less';

/** 登录页小人：眼珠跟随鼠标，密码框聚焦或有值时双手蒙眼 */
export default function LoginCharacter() {
  const leftPupilRef = useRef(null);
  const rightPupilRef = useRef(null);
  const [hideEyes, setHideEyes] = useState(false);

  // 眼珠跟随鼠标移动（直接改 transform，不触发重渲染）
  useEffect(() => {
    const MAX_MOVE = 12; // 眼珠最大移动距离，防止跑出镜框

    const moveEye = (pupil, x, y) => {
      if (!pupil) return;
      const angle = Math.atan2(y, x);
      const distance = Math.min(Math.hypot(x, y), MAX_MOVE);
      const moveX = Math.cos(angle) * distance;
      const moveY = Math.sin(angle) * distance;
      pupil.style.transform = `translate(calc(-50% + ${moveX}px), calc(-50% + ${moveY}px))`;
    };
    const onMouseMove = e => {
      [leftPupilRef.current, rightPupilRef.current].forEach(pupil => {
        if (!pupil) return;
        const rect = pupil.getBoundingClientRect();
        moveEye(pupil, e.clientX - (rect.left + rect.width / 2), e.clientY - (rect.top + rect.height / 2));
      });
    };
    document.addEventListener('mousemove', onMouseMove);
    return () => document.removeEventListener('mousemove', onMouseMove);
  }, []);

  // 密码框聚焦时蒙眼，失焦就恢复（监听原生事件，Arco 输入框同样生效）
  useEffect(() => {
    const evaluate = () => {
      const passwordInputs = Array.from(document.querySelectorAll('input[type="password"]'));
      // 只在密码框真正聚焦时蒙眼；失焦就恢复（不管有没有值）
      const focused = passwordInputs.some(el => el === document.activeElement);
      setHideEyes(focused);
    };
    document.addEventListener('focusin', evaluate);
    document.addEventListener('focusout', evaluate);
    document.addEventListener('input', evaluate);
    return () => {
      document.removeEventListener('focusin', evaluate);
      document.removeEventListener('focusout', evaluate);
      document.removeEventListener('input', evaluate);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.character} ${hideEyes ? styles['hide-eyes'] : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.ear} ${styles.earLeft}`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${styles.ear} ${styles.earRight}`
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.hair
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.face
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.mouth
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.glasses
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.lens} ${styles.lensLeft}`
  }, /*#__PURE__*/React.createElement("div", {
    ref: leftPupilRef,
    className: styles.pupil
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.bridge
  }), /*#__PURE__*/React.createElement("div", {
    className: `${styles.lens} ${styles.lensRight}`
  }, /*#__PURE__*/React.createElement("div", {
    ref: rightPupilRef,
    className: styles.pupil
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.hands
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.hand} ${styles.handLeft}`
  }), /*#__PURE__*/React.createElement("div", {
    className: `${styles.hand} ${styles.handRight}`
  })));
}